/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { withFormik } from 'formik'
/** @todo No @types for yup so have to require over import to skip TSC */
const Yup = require('yup')

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../../common/Button/Button'
import Checkbox from '../../../../common/Checkbox/Checkbox'

class AddressSecurityForm extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            toggle: false,
            showAlarmDetails: true,
        }
    }

    /**
     * set fields on Formik state and
     * also set those fields as Touched to trigger the validation
     */
    addressChange = (field: any, value: any) => {
        this.props.setFieldTouched(field, true)
        this.props.setFieldValue(field, value)
    }

    toggleCheckBox = (state: any, field: any) => {
        this.setState({ toggle: state })
    }

    /**
     * Handle the changes on Custom elements like Checkbox
     */
    handleChangeCustom = (state: any, field: any) => {
        this.props.setFieldTouched(field, true)
        this.props.setFieldValue(field, state)
    }

    /**
     * handle the click on Cancel button
     */
    handleCancel = () => {
        this.props.handleCancel()
    }

    /**
     * On focus set Label element with class 'active'
     */
    focusChange(event: any) {
        if (event.target.classList.contains('calendar__input')) {
            event.target.parentNode.parentNode.previousSibling.classList = 'active'
        } else {
            event.target.previousSibling.classList = 'active'
        }
    }

    render() {
        const {
            isCollectors,
            isMuseums,
            isDealersStock,
            isWineSpirits,
        } = this.props

        return (
            <div className="addressBlock__content">
                {(this.props.address.riskLocation) ? (
                    <div className="addressBlock__addressBar">
                        {this.props.address.riskLocation.addressLine1},
                        {this.props.address.riskLocation.addressLine2},
                        {this.props.address.riskLocation.city},
                        {this.props.address.riskLocation.postcode}
                    </div>
                ) : null}
                <form onSubmit={this.props.handleSubmit}>
                    <div className="pad_left_right">
                        <h4 className="form__w40">Security details</h4>
                        <div className="quote__form__group form__w60">
                            <Checkbox
                                onChange={this.toggleCheckBox}
                                short={true}
                                first={true}
                                last={true}
                                name="toggle"
                            >
                                Confirm all the below
                            </Checkbox>
                        </div>

                        <div className="quote__form__group form__w100">
                            <Checkbox
                                onChange={this.handleChangeCustom}
                                first={true}
                                name="goodState"
                                selectAll={this.state.toggle}
                            >
                                The premises are in a good state of repair.
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                name="notUniccupied"
                                selectAll={this.state.toggle}
                            >
                                The premises will NOT be left unoccupied
                                for more than 45 days consecutively or
                                for more than 180 days in the period of insurance.
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                name="notDamageOrExposure"
                                selectAll={this.state.toggle}
                            >
                                There has NOT previously been damage to your
                                {isCollectors ? ' collection' : isMuseums ? ' museums ' :
                                    isDealersStock ? ' Dealers stock ' : isWineSpirits ? ' Wine & Spirits ' : ' stock '}
                                or contents caused by flooding and there is not any special exposure to flood or storm.
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                name="level5Deadlocks"
                                selectAll={this.state.toggle}
                            >
                                The buildings are fitted with 5 lever mortice deadlocks to all external doors or
                                locks complying with or of superior quality than British Standard 3621.
                                Doors of UPVC or aluminium (if any) which are not fitted with specified security are
                                fitted with the manufacturer’s key operated multi point locking system.
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                last={true}
                                name="fittedWithKey"
                                selectAll={this.state.toggle}
                            >
                                The premises are fitted with key operated locks to
                                all ground, lower ground and accessible upper
                                floor windows, fanlights and skylights.
                            </Checkbox>
                        </div>

                        <h4 className="form__w100">Intruder Alarm details</h4>
                        <div className="quote__form__group form__w100">
                            <Checkbox
                                onChange={this.handleChangeCustom}
                                first={true}
                                name="alarmAtPremises"
                            >
                                There is an alarm at the premises.
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                name="alarmMaintained"
                            >
                                The alarm is maintained.
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                last={true}
                                name="alarmMonitored"
                            >
                                The alarm is monitored.
                            </Checkbox>

                            {this.props.values.alarmAtPremises ||
                                this.props.values.alarmMaintained ||
                                this.props.values.alarmMonitored ? (
                                <div>
                                    <label>Alarm details</label>
                                    <input
                                        name="alarmDetails"
                                        id="alarmDetails"
                                        type="text"
                                        placeholder="Enter your alarm details description..."
                                        onChange={this.props.handleChange}
                                        onFocus={this.focusChange}
                                    />
                                </div>
                            ) : null}
                        </div>

                        <h4 className="form__w100">Fire detection alarm details</h4>
                        <div className="quote__form__group form__w100">
                            <Checkbox
                                onChange={this.handleChangeCustom}
                                first={true}
                                name="fireDetectionAtPremises"
                            >
                                There is an alarm at the premises.
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                name="fireDetectionMaintained"
                            >
                                The alarm is maintained.
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                last={true}
                                name="fireDetectionMonitored"
                            >
                                The alarm is monitored.
                            </Checkbox>

                            {this.props.values.fireDetectionAtPremises ||
                                this.props.values.fireDetectionMaintained ||
                                this.props.values.fireDetectionMonitored ? (
                                <div>
                                    <label>Fire Alarm details</label>
                                    <input
                                        name="fireDetectionDetails"
                                        id="fireDetectionDetails"
                                        type="text"
                                        placeholder="Enter your fire alarm details description..."
                                        onChange={this.props.handleChange}
                                        onFocus={this.focusChange}
                                    />
                                </div>
                            ) : null}
                        </div>

                        <h4 className="form__w100">Additional security details</h4>
                        <div className="quote__form__group form__w100">
                            <Checkbox
                                onChange={this.handleChangeCustom}
                                name="otherSecurityDetails"
                                first={true}
                                last={true}
                            >
                                There is additional security at the premises.
                            </Checkbox>

                            {this.props.values.otherSecurityDetails ? (
                                <div>
                                    <label>Additional security details</label>
                                    <input
                                        name="securityDetailsText"
                                        id="securityDetailsText"
                                        type="text"
                                        placeholder="Enter your security details description..."
                                        onChange={this.props.handleChange}
                                        onFocus={this.focusChange}
                                    />
                                </div>
                            ) : null}

                        </div>
                    </div>
                    <div className="addressBlock__actions">

                        <Button
                            half={true}
                            type="button"
                            onClick={this.handleCancel}
                        >
                            Cancel
                        </Button>
                        <Button
                            half={true}
                            type="submit"
                            disabled={!this.props.isValid}
                        >
                            Confirm security details
                        </Button>

                    </div>

                </form>
            </div>
        )
    }
}

/**
 *     Formik Validation Struture
 */
const AddressSecurity = withFormik<any, any>({

    mapPropsToValues: (props: any) => ({
        'goodState': false,
        'notUniccupied': false,
        'notDamageOrExposure': false,
        'level5Deadlocks': false,
        'fittedWithKey': false,
        'alarmAtPremises': false,
        'alarmMaintained': false,
        'alarmMonitored': false,
        'otherSecurityDetails': false,
        'alarmDetails': '',
        'fireDetectionAtPremises': false,
        'fireDetectionMaintained': false,
        'fireDetectionMonitored': false,
        'fireDetectionDetails': '',
        'securityDetailsText': '',
    }),

    validateOnChange: true,
    validateOnBlur: true,

    validationSchema: Yup.object().shape({
        'goodState': Yup.boolean().required('This is required'),
        'notUniccupied': Yup.boolean().required('This is required'),
        'notDamageOrExposure': Yup.boolean().required('This is required'),
        'level5Deadlocks': Yup.boolean().required('This is required'),
        'fittedWithKey': Yup.boolean().required('This is required'),
        'alarmAtPremises': Yup.boolean(),
        'alarmMaintained': Yup.boolean(),
        'alarmMonitored': Yup.boolean(),
        'otherSecurityDetails': Yup.boolean(),
        'alarmDetails': Yup.string(),
        'fireDetectionAtPremises': Yup.boolean(),
        'fireDetectionMaintained': Yup.boolean(),
        'fireDetectionMonitored': Yup.boolean(),
        'fireDetectionDetails': Yup.string(),
        'securityDetailsText': Yup.string(),
    }),

    handleSubmit: (values, { props, setSubmitting }) => {
        if (!props.addressId) {

            let body = {
                'riskLocation': {
                    'addressType': props.address.riskLocation.addressType,
                    'addressLine1': props.address.riskLocation.addressLine1,
                    'addressLine2': props.address.riskLocation.addressLine2,
                    'lat': props.address.riskLocation.lat,
                    'lng': props.address.riskLocation.lng,
                    'city': props.address.riskLocation.city,
                    'postcode': props.address.riskLocation.postcode,
                    'countryId': props.address.riskLocation.countryId,
                    'securityVerified': true,
                    'goodState': values.goodState,
                    'notUniccupied': values.notUniccupied,
                    'notDamageOrExposure': values.notDamageOrExposure,
                    'level5Deadlocks': values.level5Deadlocks,
                    'fittedWithKey': values.fittedWithKey,
                    'alarmAtPremises': values.alarmAtPremises,
                    'alarmMaintained': values.alarmMaintained,
                    'alarmMonitored': values.alarmMonitored,
                    'otherSecurityDetails': values.otherSecurityDetails,
                    'alarmDetails': values.alarmDetails,
                    'fireDetectionAtPremises': values.fireDetectionAtPremises,
                    'fireDetectionMaintained': values.fireDetectionMaintained,
                    'fireDetectionMonitored': values.fireDetectionMonitored,
                    'fireDetectionDetails': values.fireDetectionDetails,
                    'securityDetailsText': values.securityDetailsText,
                },
            }

            props.handleNewAddress(body)
            props.handleCancel(false)

        } else {

            let body = {
                'riskLocation': {
                    'id': props.addressId,
                    'quoteId': props.quoteId,
                    'securityVerified': true,
                    'goodState': values.goodState,
                    'notUniccupied': values.notUniccupied,
                    'notDamageOrExposure': values.notDamageOrExposure,
                    'level5Deadlocks': values.level5Deadlocks,
                    'fittedWithKey': values.fittedWithKey,
                    'alarmAtPremises': values.alarmAtPremises,
                    'alarmMaintained': values.alarmMaintained,
                    'alarmMonitored': values.alarmMonitored,
                    'otherSecurityDetails': values.otherSecurityDetails,
                    'alarmDetails': values.alarmDetails,
                    'fireDetectionAtPremises': values.fireDetectionAtPremises,
                    'fireDetectionMaintained': values.fireDetectionMaintained,
                    'fireDetectionMonitored': values.fireDetectionMonitored,
                    'fireDetectionDetails': values.fireDetectionDetails,
                    'securityDetailsText': values.securityDetailsText,
                },
            }

            props.addLocationsSecurity(props.quoteId, props.addressId, body)
            props.handleCancel(false)
        }
        props.updateDirty(false)
    },

})(AddressSecurityForm)

export default AddressSecurity



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step02/components/AddressSecurity.tsx